import React from 'react';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='header'>
        <div className='icon' onClick={this.props.backAction}>{this.props.back}</div>
        <div className={'page_title'}>{this.props.pageName}</div>
        <div>
          {
            this.props.additionalAction ?
              <div className='icon' onClick={this.props.additionalAction}>{this.props.additional}</div>
              :
              this.props.goAction ?
                <div className='icon' onClick={this.props.goAction}>{this.props.go}</div>
                :
                <div className='icon'></div>
          }
        </div>
      </div>
    );
  }
}

export default Header;